var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewContainer',{attrs:{"title":_vm.$t('menu.admin.activity_logs')}},[_c('LogsTable',{attrs:{"columnsEnabled":_vm.columnsEnabled,"filtersEnabled":_vm.filtersEnabled},on:{"updateTable":_vm.getLogs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }